import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type DateInput = string | number | Date | null | undefined

/** Displays a calendar date as MM/DD/YYYY (e.g. 07/27/2026). Null-safe. */
export function formatDate(input?: DateInput): string {
  if (input === null || input === undefined || input === "") return "N/A"
  const d = new Date(input)
  if (isNaN(d.getTime())) return "N/A"
  return format(d, "MM/dd/yyyy")
}

/** Displays a date + time in the viewer's local timezone as MM/DD/YYYY, h:mm a (e.g. 07/27/2026, 3:30 PM). Null-safe. */
export function formatDateTime(input?: DateInput): string {
  if (input === null || input === undefined || input === "") return "N/A"
  const d = new Date(input)
  if (isNaN(d.getTime())) return "N/A"
  return format(d, "MM/dd/yyyy, h:mm a")
}
